import map from 'lodash/map';
import I18n from '../i18n/I18n';

const Allergen = {
  BALSAM_OF_PERU: 'BALSAM_OF_PERU',
  BUCKWHEAT: 'BUCKWHEAT',
  CELERY: 'CELERY',
  CHEESE: 'CHEESE',
  CORN: 'CORN',
  CRUSTACEAN: 'CRUSTACEAN',
  EGG: 'EGG',
  FISH: 'FISH',
  FRUIT: 'FRUIT',
  GARLIC: 'GARLIC',
  LACTOSE: 'LACTOSE',
  LUPINE: 'LUPINE',
  MUSTARD: 'MUSTARD',
  PEANUT: 'PEANUT',
  POULTRY_MEAT: 'POULTRY_MEAT',
  RED_MEAT: 'RED_MEAT',
  RICE: 'RICE',
  SESAME: 'SESAME',
  SHELLFISH: 'SHELLFISH',
  SOYA: 'SOYA',
  SULPHITES: 'SULPHITES',
  TARTRAZINE: 'TARTRAZINE',

  // Gluten-related
  GLUTEN: 'GLUTEN', // Generic
  GLUTEN_OATS: 'GLUTEN_OATS',
  GLUTEN_WHEAT: 'GLUTEN_WHEAT',
  GLUTEN_KAMUT: 'GLUTEN_KAMUT',
  GLUTEN_SPELT: 'GLUTEN_SPELT',
  GLUTEN_GREEN_SPELT: 'GLUTEN_GREEN_SPELT',
  GLUTEN_EINKORN: 'GLUTEN_EINKORN',
  GLUTEN_RYE: 'GLUTEN_RYE',
  GLUTEN_BARLEY: 'GLUTEN_BARLEY',
  GLUTEN_EMMER: 'GLUTEN_EMMER',
  GLUTEN_TRITICALE: 'GLUTEN_TRITICALE',

  // Nuts-related
  NUTS: 'NUTS', // Generic
  NUTS_ALMONDS: 'NUTS_ALMONDS',
  NUTS_HAZELNUTS: 'NUTS_HAZELNUTS',
  NUTS_WALNUTS: 'NUTS_WALNUTS',
  NUTS_CASHEW: 'NUTS_CASHEW',
  NUTS_PECANS: 'NUTS_PECANS',
  NUTS_BRAZIL: 'NUTS_BRAZIL',
  NUTS_PISTACHES: 'NUTS_PISTACHES',
  NUTS_MACADAMIA_OR_QUEENSLAND: 'NUTS_MACADAMIA_OR_QUEENSLAND',
};

export const getAllergenLabel = (allergen) => {
  return I18n.tr(`global.allergen.${allergen}`);
}

export const getAllergenOptions = () =>
  map(Allergen, value => ({
    label: getAllergenLabel(value),
    value: value,
  }));
